import { Cpu, Gamepad2, Video, Heart, ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const QUADRANTS = [
  { icon: Cpu, label: "Artificial Intelligence", path: "/market/artificial-intelligence" },
  { icon: Gamepad2, label: "Interactive Entertainment", path: "/market/interactive-entertainment" },
  { icon: Video, label: "Real-Time Video", path: "/market/real-time-video" },
  { icon: Heart, label: "Virtual Companions", path: "/market/virtual-companions" },
];

export default function Market() {
  return (
    <section id="market" data-testid="market-section" className="relative bg-[#0a0a0a] py-16 lg:py-36">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-2 lg:px-10">
        <Reveal>
          <SectionTag>Market</SectionTag>
          <h2 className="font-display mt-5 text-3xl font-light tracking-tighter text-white sm:text-4xl lg:text-5xl">
            At the Intersection of <span className="text-cyan-300">AI and Entertainment</span>
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-[#C5CBD5]">
            AIROBOTCAMSTUDIO sits where four fast-moving domains meet — combining conversational
            intelligence, cinematic character presentation and live video into one interactive
            entertainment experience.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative grid grid-cols-2 gap-3">
            {QUADRANTS.map(({ icon: Icon, label, path }, i) => (
              <a
                key={label}
                href={path}
                data-testid={`market-quadrant-${i}`}
                className="group flex aspect-square flex-col items-start justify-between rounded-2xl border border-cyan-300/15 bg-black/40 p-5 transition-colors duration-500 hover:border-cyan-300/40 sm:p-6"
              >
                <Icon size={20} className="text-cyan-300/80 transition-transform duration-500 group-hover:-translate-y-0.5" />
                <span>
                  <span className="font-display block text-sm font-medium leading-snug tracking-tight text-white/85">
                    {label}
                  </span>
                  <span className="mt-1.5 inline-flex items-center gap-1 text-[9px] font-semibold uppercase tracking-[0.18em] text-cyan-300/70 transition-colors duration-300 group-hover:text-cyan-100">
                    Learn more
                    <ArrowRight size={10} className="transition-transform duration-300 group-hover:translate-x-0.5" />
                  </span>
                </span>
              </a>
            ))}
            <div className="pointer-events-none absolute left-1/2 top-1/2 hidden -translate-x-1/2 -translate-y-1/2 lg:block">
              <div className="flex h-24 w-24 items-center justify-center rounded-full border border-cyan-300/30 bg-black/80 text-center shadow-[0_0_60px_rgba(0,229,255,0.2)] backdrop-blur-xl">
                <span className="font-display text-[9px] font-semibold leading-tight tracking-[0.2em] text-cyan-200">
                  AIROBOT<br />CAM<br />STUDIO
                </span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
